import script from "./supplierEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./supplierEdit.vue?vue&type=script&setup=true&lang=js"

import "./supplierEdit.vue?vue&type=style&index=0&id=abbc5734&lang=scss&scoped=true"
import "./supplierEdit.vue?vue&type=style&index=1&id=abbc5734&lang=css"

import exportComponent from "D:\\workCode\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-abbc5734"]])

export default __exports__